import React, { useState, Fragment } from "react";
import './Payitems.css';
import { nanoid } from "nanoid";
import data from "./Addition/mock-data1.json";
import data2 from "./Deduction/mock-data2.json";
import ReadOnlyRow2 from "./Deduction/ReadOnlyRow2";
import ReadOnlyRow1 from "./Addition/ReadOnlyRow1";
import EditableRow1 from "./Addition/EditableRow1";
import EditableRow2 from "./Deduction/EditableRow2";
const Payitems=()=>{
    // /----Add Addition----------/ 
    const [contacts, setContacts] = useState(data);
  const [addFormData, setAddFormData] = useState({
    namee: "",
    category: "",
    amount: ""
    
  });
  const [editFormData, setEditFormData] = useState({
    namee: "",
    category: "",
    amount: ""
  });
  const [editContactId, setEditContactId] = useState(null);

  const handleAddFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;

    setAddFormData(newFormData);
  };
  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);
  };
  const handleAddFormSubmit = (event) => {
    event.preventDefault();
    const newContact = {
        id: nanoid(),
        namee: addFormData.namee,
        category: addFormData.category,
        amount: addFormData.amount
       
      };
  
      const newContacts = [...contacts, newContact];
    
      setContacts(newContacts);
    };
    const handleEditFormSubmit = (event) => {
        event.preventDefault();
    
        const editedContact = {
          id: editContactId,
          namee: editFormData.namee,
          category: editFormData.category,
          amount: editFormData.amount
         
        };
    
        const newContacts = [...contacts];
    
        const index = contacts.findIndex((contact) => contact.id === editContactId);
    
        newContacts[index] = editedContact;
    
        setContacts(newContacts);
        setEditContactId(null);
      };
      const handleEditClick = (event, contact) => {
        event.preventDefault();
        setEditContactId(contact.id);
    
        const formValues = {
          namee: contact.namee,
          category: contact.category,
          amount:contact.amount
         
        };
    
        setEditFormData(formValues);
      };
      const handleCancelClick = () => {
        setEditContactId(null);
      };
      const handleDeleteClick = (contactId) => {
        const newContacts = [...contacts];
    
        const index = contacts.findIndex((contact) => contact.id === contactId);
    
        newContacts.splice(index, 1);
    
        setContacts(newContacts);
      };

    //   -------------------Add Deduction------------------------------
    const [contacts2, setContacts2] = useState(data2);
  const [addFormData2, setAddFormData2] = useState({
    namee2: "",
    
    amount2: ""
    
  });
  const [editFormData2, setEditFormData2] = useState({
    namee2: "",
   
    amount2: ""
  });
  const [editContactId2, setEditContactId2] = useState(null);

  const handleAddFormChange2 = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData2 = { ...addFormData2 };
    newFormData2[fieldName] = fieldValue;

    setAddFormData2(newFormData2);
  };
  const handleEditFormChange2 = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData2 = { ...editFormData2 };
    newFormData2[fieldName] = fieldValue;

    setEditFormData2(newFormData2);
  };
  const handleAddFormSubmit2 = (event) => {
    event.preventDefault();
    const newContact2 = {
        id: nanoid(),
        namee2: addFormData2.namee2,
       
        amount2: addFormData2.amount2
       
      };
  
      const newContacts2 = [...contacts2, newContact2];
    
      setContacts2(newContacts2);
    };
    const handleEditFormSubmit2 = (event) => {
        event.preventDefault();
    
        const editedContact2 = {
          id: editContactId2,
          namee2: editFormData2.namee2,
        
          amount2: editFormData2.amount2
         
        };
    
        const newContacts2 = [...contacts2];
    
        const index = contacts2.findIndex((contact2) => contact2.id === editContactId2);
    
        newContacts2[index] = editedContact2;
    
        setContacts2(newContacts2);
        setEditContactId2(null);
      };
      const handleEditClick2 = (event, contact2) => {
        event.preventDefault();
        setEditContactId2(contact2.id);
    
        const formValues = {
          namee2: contact2.namee2,
         
          amount2:contact2.amount2
         
        };
    
        setEditFormData2(formValues);
      };
      const handleCancelClick2 = () => {
        setEditContactId2(null);
      };
      const handleDeleteClick2 = (contactId2) => {
        const newContacts2 = [...contacts2];
    
        const index = contacts2.findIndex((contact2) => contact2.id === contactId2);
    
        newContacts2.splice(index, 1);
    
        setContacts2(newContacts2);
      };
    return(<div className="Payitems" id="Payitems">
        {/* <!-- Top Bar --> */}
    <div className="container-fluid1 py-2 icueTopBarContainer bg-white">
        <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="topBarLfContainer d-flex">
                    <div className="icueLogoContainer">
                        <img src="images/logo.png" alt="ICue Logo" className="icueLogo" />
                    </div>
                    <div className="icueSearchBox w-75 mx-3">
                        <div className="input-group ">
                            <span className="input-group-text" id="basic-addon1">
                                <i className="bi bi-search"></i>
                            </span>
                            <input type="search" id="text-search" className="form-control icueSearchBoxControl" placeholder="Enter keywords..." aria-label="Username" aria-describedby="basic-addon1"/>
                          </div>
                    </div>
                </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="d-flex flex-row-reverse">
                    <div className="icueProfile px-2">
                        <img src="images/avatar.png" alt="icueProfilePic" className="icueProfilePic border border-dark rounded-circle" />
                    </div>
                    <div className="position-relative px-2">
                        <a href="#" id="icueNotifyBoxHandler">
                            <i className="bi bi-bell">
                                <span className="position-absolute icueNofIndic"></span>
                            </i>
                        </a>
                        <div className="icueNotifyBox" id="icueNotifyBox">
                            Notifications
                        </div>
                    </div>

                    <div className="icueUserName fs-6 px-2">
                        Viral Patel
                    </div>

                    <div className="icueMail px-2">
                        <i className="bi bi-headset"></i> &nbsp;
                        adminhelpdesk@gmail.com
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- /Top Bar -->

    <!-- Main Body --> */}
    <div className="container-fluid my-2">
        <div className="row">
            <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12 bg-white">
                <div className="icueRespSideBar d-xxl-none d-xl-none d-lg-none d-md-block d-sm-block d-block" id="icueRespSideBar">
                    <button type="button" className="btn btn-primary" id="icueRespHumburger">
                        <i className="bi bi-grid-3x3-gap"></i>
                    </button>
                    <div className="icueSideBar" id="icueSideBar">
                        <nav className="navbar icueSideNavContainer">
                            <ul className="icueNavBarList">
                                <li className="icueNavBarItem ">
                                    <a href="/Hrdashboard" className="icueNavBarLink" id="">Dashboard</a>
                                </li>
                                <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">User Management</a>
                            </li>

                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem">
                                        {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                        <a href="#" className="icueSubNavLink  text-capitalize">Add Members</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="/ListMembers" className="icueSubNavLink  text-capitalize">List of Members</a>
                                    </li>
                                </ul>
                            </li>
                            <hr></hr>

                                <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">Leave Management</a>
                            </li>

                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem">
                                        {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                        <a href="/Leaves" className="icueSubNavLink  text-capitalize">Leaves</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="/LeaveType" className="icueSubNavLink  text-capitalize">Leave Type</a>
                                    </li>
                                </ul>
                            </li>
                            <hr></hr>
                            <li className="icueNavBarItem border-bottom-1">
                                <a href="/Holidays" className="icueNavBarLink" id="">Holidays</a>
                            </li>                            
                            <li className="icueNavBarItem border-bottom-1">
                                <a href="/Attendance" className="icueNavBarLink" id="">Attendance</a>
                            </li>                       
    
                                 
    
                                <li className="icueNavBarItem">
                                    <a href="/Department" className="icueNavBarLink" id="">Department</a>
                                </li>
    
                                <li className="icueNavBarItem">
                                    <a href="/AddRoles" className="icueNavBarLink" id="">Roles</a>
                                </li>
                                
                                <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">Payroll</a>
                            </li>
                            <li  >
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem"  style={{marginLeft:"-20px" , marginTop:"-10px"}}>
                                        <a href="/EmpSalary" className="icueSubNavLink  text-capitalize">Employee Salary</a>
                                    </li>                                    
                                </ul>                                
                            </li>
                            <li className="active">
                                <ul>
                                <li className="icueSubNavItem">
                                        <a href="/Payitems" className="icueSubNavLink  text-capitalize">Payroll Items</a>
                                    </li>
                                </ul>
                            </li>
                                <hr/>
                                <li className="icueNavBarItem border-bottom-0" style={{marginTop:"-18px"}}>
                                    <a href="#" className="icueNavBarLink" id="">Settings</a>
                                </li>
                                <li>
                                    <ul className="icueSubNavBar">
                                        <li className="icueSubNavItem">
                                            <a href="#" className="icueSubNavLink  text-capitalize">Change Password</a>
                                        </li>
                                        <li className="icueSubNavItem">
                                            <a href="#" className="icueSubNavLink  text-capitalize">Profile</a>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>

                <div className="icueNavSideBar d-xxl-block d-xl-block d-lg-block d-md-none d-sm-none d-none" id="icueNavSideBar">
                    <nav>
                        <ul className="icueNavBarList">
                            <li className="icueNavBarItem ">
                                <a href="/Hrdashboard" className="icueNavBarLink" id="">Dashboard</a>
                            </li>

                            <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">User Management</a>
                            </li>

                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem"  style={{marginTop:"-8px"}}>
                                        {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                        <a href="#" className="icueSubNavLink  text-capitalize">Add Member</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="/ListMembers" className="icueSubNavLink  text-capitalize">List of Members</a>
                                    </li>
                                </ul>
                            </li>
                            <hr></hr>

                            <li className="icueNavBarItem border-bottom-0" style={{marginTop:"-18px"}}>
                                <a href="#" className="icueNavBarLink" id="" >Leave Management</a>
                            </li>

                            <li>
                                <ul className="icueSubNavBar ">
                                    <li className="icueSubNavItem" style={{marginTop:"-8px"}}>
                                        {/* <!-- <a href="#" data-bs-toggle="modal" data-bs-target="#addid" data-bs-whatever="@getbootstrap" className="icueSubNavLink  text-capitalize">Add Member</a> --> */}
                                        <a href="/Leaves" className="icueSubNavLink  text-capitalize">Leaves</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="/LeaveType" className="icueSubNavLink  text-capitalize">Leave Type</a>
                                    </li>
                                </ul>
                                <hr></hr>
                            </li>              

                            <li className="icueNavBarItem "style={{marginTop:"-18px"}}>
                                <a href="/Holidays" className="icueNavBarLink" id="">Holidays</a>
                            </li>   
                            <li className="icueNavBarItem ">
                                <a href="/Attendance" className="icueNavBarLink" id="">Attendance</a>
                            </li>   
                            
                            

                            
                            <li className="icueNavBarItem" >
                                <a href="/Department" className="icueNavBarLink" id="">Department</a>
                            </li>

                            <li className="icueNavBarItem">
                                <a href="/AddRoles" className="icueNavBarLink" id="">Roles</a>
                            </li>
                            

                            <li className="icueNavBarItem border-bottom-0">
                                <a href="#" className="icueNavBarLink" id="">Payroll</a>
                            </li>
                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem" style={{marginTop:"-10px"}}>
                                        <a href="/EmpSalary" className="icueSubNavLink  text-capitalize">Employee Salary</a>
                                    </li>                                    
                                </ul>                                
                            </li>
                            <li className="active">
                                <ul>
                                <li className="icueSubNavItem" style={{marginLeft:"-20px"}}>
                                        <a href="/Payitems" className="icueSubNavLink  text-capitalize">Payroll Items</a>
                                    </li>
                                </ul>
                            </li>
                           <hr/>
                            <li className="icueNavBarItem border-bottom-0"  style={{marginTop:"-18px"}}>
                                <a href="#" className="icueNavBarLink" id="">Settings</a>
                            </li>
                            <li>
                                <ul className="icueSubNavBar">
                                    <li className="icueSubNavItem">
                                        <a href="#" className="icueSubNavLink  text-capitalize">Change Password</a>
                                    </li>
                                    <li className="icueSubNavItem">
                                        <a href="#" className="icueSubNavLink  text-capitalize">Profile</a>
                                    </li>
                                </ul>
                                <hr></hr>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>

            <div className="col-xxl-10 col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 ">
                <main className="mainBodyContainer">
                    <div className="row my-2">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-3">
                            <div className="d-flex justify-content-between">
                                <h4 className="text-captalize"style={{fontFamily:"ErasDemiITC", fontWeight:"bold", marginTop:"1rem", marginLeft:"12px"}}>Payroll Items</h4>
                                <div className="bg-transparent p-2  rounded-3">
                                <nav style={{bsbreadcrumbdivider: 'url(&#34;"data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="8" height="8"%3E%3Cpath d="M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z" fill="currentColor"/%3E%3C/svg%3E&#34")'}} aria-label="breadcrumb">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item bg-transparent" style={{fontFamily:"Calibri", fontSize:"bold"}}><a href="/Hrdashboard" className="text-decoration-none text-info">Dashboard</a></li>
                                        <li className="breadcrumb-item bg-transparent" style={{fontFamily:"Calibri"}}><a href="#" className="text-decoration-none text-info">Payroll</a></li>
                                        <li className="breadcrumb-item text-muted text-capitalize bg-transparent" aria-current="page" style={{  fontSize:"bold"}}>Payroll Items</li>
                                    </ol>
                                </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    <div className="row my-2">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-1 px-3" >
                            <div className="bg-white p-2  rounded-3 shadow-sm">
                                <div className="px-2 py-3">                  
                                      <div className="container1">
                                           <div className="row">
                                             <div className=" col-xs-12 bg-white ">
                                                 <ul className="nav nav-tabs" id="myTab" role="tablist" style={{marginTop:"-25px", marginLeft:"30px"}}>
                                                    <li className="nav-item">
                                                      <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Additions</a>
                                                    </li>
                                                    <li className="nav-item">
                                                       <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Deductions</a>
                                                     </li>                                       

                                                 </ul>

                                             
                                              </div>
                                              
                                               <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12  bg-white">
                                                    <div className="tab-content py-1 px-3 px-sm-0" id="myTabContent">
                                                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                                        <a href="#" type="button" className=" icueBgPrimary text-white pt-2  " data-bs-toggle="modal" data-bs-target="#addid1" style={{fontFamily:"Calibri", color:"white", fontSize:"bold", height:"30px", lineHeight:"10px",  width:"125px", marginLeft:"890px", textAlign:"center"}}><i className="bi bi-plus-circle"></i> &nbsp;   Add Addition</a>   
                                                                         
                                                             
                                                               <form id="icueFollowInfoForm" onSubmit={handleEditFormSubmit}>
                                            <table id="payrollTable" className="table table-striped table-hover  " width="auto" >
                                                <thead>
                                                    <tr className="text-uppercase" style={{lineHeight:"15px", fontFamily:"Calibri", fontStyle:"normal",  fontSize:"12px", backgroundColor:"#F4F7FC"}}>
                                                        <th className="text-left py-3">Name</th>
                                                        <th  className="text-left py-3">Category</th>
                                                        <th  className="text-right py-3">Default/ Unit amount</th>
                                                        <th  className="text-right py-3">Actions</th>
                                                                                                               
                                                    </tr>
                                                </thead>
                                                <tbody style={{lineHeight:"15px", fontFamily:"Calibri", fontSize:"16px"}}>
                                                    
                                                   {contacts.map((contact) => (
                                                      <Fragment>
                                                        {editContactId === contact.id ? (
                                                            <EditableRow1
                                                              editFormData={editFormData}
                                                              handleEditFormChange={handleEditFormChange}
                                                              handleCancelClick={handleCancelClick} />
                                                             ) : (
                                                             <ReadOnlyRow1
                                                             contact={contact}
                                                             handleEditClick={handleEditClick}
                                                             handleDeleteClick={handleDeleteClick} />
                                                             )}
                                                       </Fragment>
            ))}
                                                </tbody>
                                            </table>
                                            </form>
                                       
                                   
                                     
                                   </div>
                                   
                                        <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                            <div className="row">              
                                                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12  bg-white"> 
                                                  <a href="#" type="button" className=" icueBgPrimary text-white pt-2 top-right " data-bs-toggle="modal" data-bs-target="#addid2" style={{fontFamily:"Calibri", color:"white", fontSize:"bold", height:"30px", lineHeight:"10px", marginTop:"-270px", width:"125px", marginLeft:"850px", textAlign:"center"}}><i className="bi bi-plus-circle"></i> &nbsp;   Add Deduction</a>
                                                  <form id="icueFollowInfoForm" onSubmit={handleEditFormSubmit2}>
                                                 
                                                     <table id="payrollTable" className="table  table-hover table-striped  " width="100%" >
                                                <thead>
                                                   
                                                    <tr className="text-uppercase" style={{lineHeight:"15px", fontFamily:"Calibri",   fontStyle:"normal",  fontSize:"12px", backgroundColor:"#F4F7FC", marginLeft:"20px"}}>
                                                        <th className="text-left py-3" >Name</th>
                                                       
                                                        <th  className="text-right py-3">Default/ Unit amount</th>
                                                        
                                                        <th className="text-right py-3" >Actions</th>
                                                                                                               
                                                    </tr>
                                                </thead>
                                                <tbody style={{lineHeight:"15px", fontFamily:"Calibri", fontSize:"16px"}}>
                                                    {/* <tr  style={{ border:"0"}}>
                                                        <td >Provident Fund</td>
                                                        
                                                        <td className="text-center">2600</td>
                                                        <td></td>
                                                        <td  className="text-center py-0">  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                         <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>

                                                    <tr style={{ border:"0", backgroundColor:"#F4F7FC"}}>
                                                        <td >LWF</td>
                                                        
                                                        <td className="text-center">50</td>
                                                        <td></td>
                                                        <td className="text-center py-0">  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>
                                                    <tr  style={{ border:"0"}}>
                                                        <td >Unpaid Leave</td>
                                                         
                                                        <td className="text-center">1000</td>
                                                        <td></td>
                                                        <td className="text-center py-0" >  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr>
                                                    <tr style={{ border:"0", backgroundColor:"#F4F7FC"}}>
                                                        <td >Group Mediclaim</td>
                                                         
                                                        <td className="text-center">596</td>
                                                        <td></td>
                                                        <td className="text-center py-1">  <button type='button'className='btn btn-sm btn-transparent editModal text-muted' id='editMod_1'> <a href="#"><i className='bi bi-pencil'></i></a></button> 
                                                        <button type='button' className='btn btn-sm btn-transparent icueDelBtnRow text-muted' id='remMod_1'style={{marginLeft:"-30px"}}><i className='bi bi-trash'></i></button> </td>
                                                                                                            
                                                    </tr> */}
                                                    {contacts2.map((contact2) => (
              <Fragment>
                {editContactId2 === contact2.id ? (
                  <EditableRow2
                    editFormData2={editFormData2}
                    handleEditFormChange2={handleEditFormChange2}
                    handleCancelClick2={handleCancelClick2}
                  />
                ) : (
                  <ReadOnlyRow2
                    contact2={contact2}
                    handleEditClick2={handleEditClick2}
                    handleDeleteClick2={handleDeleteClick2}
                  />
                )}
              </Fragment>
            ))}
                                                </tbody>
                                            </table>
                                            
                                            </form>
                                        </div>
                                    </div>   
</div>
<div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
<div className="row my-2" >
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-2 px-3 pb-0 mb-0">
                            <div className=" p-2  rounded-3 shadow-sm" style={{marginLeft:"-1rem", marginRight:"-1rem", backgroundColor:"#F1F2F6",marginTop:"-10px"}}>
                                <div className="px-4 py-1">
                                    <div className="row">                                       
                                        <div className="row" style={{marginTop:"-45px"}}>
                                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" style={{marginTop:"52px"}}>
                                   <div className="icueSearchBox w-75 mx-3 " style={{marginLeft:"10px"}}>
                                      <div className="input-group ">
                                      <span className="input-group-text bg-white" id="basic-addon1">
                                         <i className="bi bi-search"></i>
                                      </span>
                                         <input type="search" className="form-control icueSearchBoxControl bg-white" placeholder="Search by Policy No., Insurance Type, Company Name" aria-label="Username" aria-describedby="basic-addon1"/>
                                       </div>
                                   </div>
                                </div>
                                            
                                            <div className="col-lg-3 col-md-3 col-sm-3 col-3 pt-4" style={{marginTop:"10px", marginLeft:"118px"}}>
                                            <label className="text-muted" for=""></label>
                                                 <br/>
                                                <div className="form-group pb-0 mb-0" >
                                                <a href="/AddNew" type="button" className="btn icueBgPrimary text-white  rounded-3 w-78  "  style={{fontFamily:"Calibri", color:"white", fontSize:"bold", height:"35px", lineHeight:"10px", marginTop:"15px", marginLeft:"300px", width:"100px"}}> Add New</a>

                                                
                                                </div>             
                                    
                                            </div>
                                            </div>
                                            </div>
                                            </div>
                                            </div>
                                            </div>
                                            </div>

</div>
</div>
</div>
</div>
</div>

        </div>
    </div>
</div>
</div>
<div className="modal" id="addid1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content rounded-3">
            <div className="modal-header d-flex flex-column" id="addModalHeader">
                <div className="text-end w-100" >
                    <button type="button" className="btn text-muted " data-bs-dismiss="modal" ><i className="bi bi-x-circle" style={{color:"#8692A6"}}></i></button>
                </div>
                <div className="text-center">
                    <h5 className="modal-title" style={{color:"black", fontFamily:'ErasDemiITC'}}>Add Addition</h5>
                    {/* <p className="text-muted">Please add a valid email</p> */}
                </div>
            </div>
            <br/>
            <div className="modal-body" id="addModalBody">
                <form className="">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="form-group pb-2">
                                <input className="form-control" type="text" name="namee"  onChange={handleAddFormChange} placeholder="Name"  />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="form-group pb-2">
                                <select className="form-select text-muted" aria-label="icueAddDepartment" name="category" onChange={handleAddFormChange}>
                                    <option>Monthly remuneration</option>
                                    <option value="marketing">Additional remuneration</option>                                                                      
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="form-group pb-2">
                                <input className="form-control" type="text" name="amount" placeholder="Unit Amount"  onChange={handleAddFormChange} />
                            </div>
                        </div>                     
                       
                        
                        <div className="col-12 py-3">
                            <div className="d-grid gap-2">
                                <button type="button" data-bs-dismiss="modal" className="btn text-white " onClick={handleAddFormSubmit} style={{backgroundColor:"#3A3285"}}>
                                   Submit
                                </button>
                            </div>
                        </div>
                    </div>                   
                </form>
            </div>
        </div>
    </div>
</div>


<div className="modal" id="addid2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content rounded-3">
            <div className="modal-header d-flex flex-column" id="addModalHeader">
                <div className="text-end w-100" >
                    <button type="button" className="btn text-muted " data-bs-dismiss="modal" ><i className="bi bi-x-circle" style={{color:"#8692A6"}}></i></button>
                </div>
                <div className="text-center">
                    <h5 className="modal-title" style={{color:"black", fontFamily:'ErasDemiITC'}}>Add Deduction</h5>
                    {/* <p className="text-muted">Please add a valid email</p> */}
                </div>
            </div>
            <br/>
            <div className="modal-body" id="addModalBody">
                <form className="">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="form-group pb-2">
                                <input className="form-control" type="text" name="namee2" onChange={handleAddFormChange2} placeholder="Name"  />
                            </div>
                        </div>
                        
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="form-group pb-2">
                                <input className="form-control" type="text" name="amount2" onChange={handleAddFormChange2} placeholder="Unit Amount"  />
                            </div>
                        </div>
                        
                       
                        
                        <div className="col-12 py-3">
                            <div className="d-grid gap-2">
                                <button type="button" data-bs-dismiss="modal" className="btn text-white " onClick={handleAddFormSubmit2} style={{backgroundColor:"#3A3285"}}>
                                   Submit
                                </button>
                            </div>
                        </div>
                    </div>

                    
                </form>
            </div>
        </div>
    </div>
</div>
</main>
</div>
        </div>
    </div>
</div>
    )}
    export default Payitems;